module.exports = __webpack_public_path__ + "img/emp1-3.c0ecb2dc.jpg";